import DuoLogin from './DuoLogin';

export default DuoLogin;
